<template>
  <div class="doorFee">
    <el-form ref="form" :model="form">
      <el-row>
        <div class="topTitle">上门服务费配置</div>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <label>
            <span>当前上门费:</span>
          </label>{{form? '一口价&nbsp;&nbsp;'+ form.fee +'&nbsp;&nbsp;元/次':'--'}}
          <el-button size="mini" type="danger" @click="editFee">修改</el-button>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="8">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <label>
            <span>未生效上门费:</span>
          </label>--
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <label>
            <span>生效时间:</span>
          </label>
          --
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="8">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <label>
            <span>最近修改时间:</span>
          </label>
          {{form?form.modTime:'--'}}
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="上门服务费配置" :visible.sync="dialogTableVisible" :center="true" width="580px">
      <!-- 修改销售提成 -->
      <el-form ref="childForm" :model="childForm" :rules="rules" label-width="120px" class="feeSetup">
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="15">
            <el-form-item label="当前上门费">{{form? '一口价&nbsp;&nbsp;'+ form.fee +'&nbsp;&nbsp;元/次':'--'}}</el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:20px 0;">
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="15">
              <el-row>
                <el-col :span="16">
                    <el-form-item label="上门费" prop="doorType">
                        <el-select
                            v-model="childForm.doorType"
                            placeholder="请选择上门费"
                            style="margin-right: 10px"
                        >
                            <el-option label="一口价" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="fee" label-width="0">
                        <el-input v-model="childForm.fee" placeholder="输入价格"></el-input>
                    </el-form-item>
                </el-col>
              </el-row>
          </el-col>
          <el-col :span="6">
            <span class="unitFee">&nbsp;&nbsp;元/次</span>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="15">
            <el-form-item label="生效时间" prop="time">
              <el-date-picker
                v-model="childForm.time"
                type="datetime"
                placeholder="选择生效时间"
                value-format="timestamp"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="resetData">取消</el-button>
          <el-button class="redBtn" @click="onSubmit">保存</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { queryHomeFee, operateHomeFee } from "@/api";

export default {
  data() {
      // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 99999.99) {
          callback(new Error("金额最大99999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else if (!value || value == "") {
        callback();
      } else {
        callback(new Error("金额只能是数字，且保留两位小数"));
      }
    };
    return {
      form: {},
      childForm: {
        doorType: "1",
        fee: "",
        time: ""
      },
      rules: {
        doorType:[
            {required: true,
            message: "请选择上门费方式",
            trigger: "change"}
        ],
        fee: [
          {
            required: true,
            message: "请输入上门费",
            trigger: "blur"
          },
          { type: "number", validator: isvalidateMoney }
        ],
        time: [
          {
            required: true,
            message: "请选择生效时间",
            trigger: "change"
          }
        ],
      },
      dialogTableVisible: false
    };
  },
  created() {
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      queryHomeFee().then(res => {
        if (res.code == 1) {
          this.form = res.data;
        }
      });
    },
    editFee() {
      // 上门服务费配置
      this.dialogTableVisible = true;
    },
    resetData() {
      // 取消
        this.$message({
            type: "info",
            message: "已取消"
        });
        this.dialogTableVisible = false;
    },
    onSubmit() {
      // 确定
      this.$refs.childForm.validate(valid => {
        if (valid) {
          operateHomeFee(this.childForm).then(res => {
            if (res.code == 1) {
              // 关闭当前进入列表页
              this.dialogTableVisible = false;
              this.detailInfo();
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.doorFee {
  width: 100%;
  overflow: hidden;
  padding: 100px 50px 70px;
  position: relative;
  .el-row {
    margin-bottom: 28px;
  }
  .feeSetup {
    .el-row {
      margin-bottom: 0;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .unitFee {
      line-height: 40px;
    }
  }
  label {
    width: 100px;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    color: #666;
  }
  .el-button--mini {
    margin-left: 30px;
  }
  .seize {
    height: 20px;
  }
  .topTitle {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
}
</style>
<style lang="less">
.doorFee {
  .el-dialog__title {
    font-weight: bold;
  }
  .feeSetup {
    .el-input__inner {
      height: 35px;
      line-height: 35px;
    }
    .el-form-item__error{
        width:200px;
    }
  }
  .btnOptions {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/basicDataCenter/todoorFee.vue